// const DEFAULT_PRODUCT_TAB_TYPE_WHEN_MANY = ['community_solar', 'ppa'];

export default class ProposalHelper {
  static determineFinancingMethodToFetch({ financingMethods }, view) {
    if (financingMethods.length > 0) {
      // if (view && view.financingMethodId) {
      // eslint-disable-next-line eqeqeq
      const fmMatchingId = financingMethods.find(({ isPrimary, primary }) => isPrimary || primary); // isPrimary FM/ primary liteFinancingMethod
      if (fmMatchingId) {
        return fmMatchingId;
      }
      // }

      // if (financingMethods.length > 1) {
      //   let financingMethod = DEFAULT_PRODUCT_TAB_TYPE_WHEN_MANY.reduce((acc, type) => {
      //     let fMExists = financingMethods.find(({ productType }) => productType === type);
      //     if (!acc && fMExists) return fMExists;
      //     return acc;
      //   }, null);
      //
      //   if (financingMethod) {
      //     return financingMethod;
      //   }
      //
      //   const primaryFm = financingMethods.find(({ primary }) => primary);
      //   if (primaryFm) return primaryFm;
      // }
      // return financingMethods[0];
    }

    return null;
  }

  static isFinancingMethodValid({ financingMethod }) {
    return financingMethod && financingMethod?.status !== 'invalid' && financingMethod?.calculationModelId !== null;
  }

  static determineProductValidityWithFinancingMethods(financingMethods, type) {
    if (financingMethods.length) {
      let financingMethod = financingMethods.filter((item) => {
        return item.productType === type;
      });

      return this.isFinancingMethodValid({ financingMethod: financingMethod[0] });
    }
    return null;
  }
}
